<template>
  <bj-modal
    v-if="visible"
    v-model="visible"
    size="auto"
    title="Generate Device Code"
  >
    <div slot="content">
      <div v-if="!loading">
        <div class="title">
          Generated device code for {{ moment().tz(unit.property.timezone).format('MM/DD/YY') }}
        </div>
        <div class="mb-3">
          <span class="font-weight-bold">device code:</span>
          <span>
            {{ deviceCode }}
          </span>
          <SdCopyToClipboard
            with-icon
            :copy="deviceCode"
            class="ml-2"
          />
        </div>
      </div>
      <div v-else>
        Loading your device code...
        <q-spinner-puff
          color="primary"
          size="60px"
        />
      </div>
      <div slot="footer">
        <q-btn-group
          rounded
          flat
        >
          <q-btn
            rounded
            color="primary"
            size="lg"
            outline
            label="Close"
            no-caps
            @click.prevent="close"
          />
        </q-btn-group>
      </div>
    </div>
  </bj-modal>
</template>

<script>
import SdCopyToClipboard from './common/SdCopyToClipboard';

export default {
  components: {
    SdCopyToClipboard,
  },
  data() {
    return {
      visible: false,
      loading: true,
      deviceCode: '',
      unit: {},
    };
  },
  methods: {
    show(unit) {
      this.unit = unit;
      this.visible = true;
      const url = `admin/devices/${unit.device_id}/daily-code`;
      this.api().request('GET', url).then((response) => {
        this.deviceCode = response.toString();
        this.loading = false;
      }).catch((error) => {
        setTimeout(() => {
          this.visible = false;
          this.uiNotify(error.message || 'Error occurred, please try again', 'negative', 5000);
        }, 1000);
      });
    },
    close() {
      this.visible = false;
      this.loading = true;
      this.deviceCode = '';
    },
  },
};
</script>
